import axios from 'axios';
import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const createDeliveryGuide = async (branchId, data) =>
  (await axios.post(`${API_URL}/branch/${branchId}/delivery-guides`, data, withAuth())).data;

export const createBulkDeliveryGuides = async (branchId, data) =>
  (await axios.post(`${API_URL}/branch/${branchId}/delivery-guides/bulk`, data, withAuth())).data;

export const createTransferDeliveryGuide = async (branchId, data) =>
  (await axios.post(`${API_URL}/branch/${branchId}/delivery-guides/transfer`, data, withAuth())).data;

export const createOutboundTransferDeliveryGuide = async (branchId, data) =>
  (await axios.post(`${API_URL}/branch/${branchId}/delivery-guides/transfer/outbound`, data, withAuth())).data;

export const getTransferBranches = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/delivery-guides/transfer/branches`, {
    ...withAuth(),
    params,
  })).data;

export const getTransferStockListsByContext = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/delivery-guides/transfer/stock-lists`, {
    ...withAuth(),
    params,
  })).data;

export const getTransferStockListItemsByContext = async (branchId, stockListId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/delivery-guides/transfer/stock-lists/${stockListId}/items`, {
    ...withAuth(),
    params,
  })).data;

export const getDeliveryGuides = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/delivery-guides`, {
    ...withAuth(),
    params,
  })).data;

export const getSalesMissingDeliveryGuides = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/delivery-guides/missing-sales`, {
    ...withAuth(),
    params,
  })).data;

export const getDeliveryGuideById = async (branchId, id) =>
  (await axios.get(`${API_URL}/branch/${branchId}/delivery-guides/${id}`, withAuth())).data;

export const updateDeliveryGuide = async (branchId, id, data) =>
  (await axios.patch(`${API_URL}/branch/${branchId}/delivery-guides/${id}`, data, withAuth())).data;

export const deleteDeliveryGuide = async (branchId, id) =>
  (await axios.delete(`${API_URL}/branch/${branchId}/delivery-guides/${id}`, withAuth())).data;

export const getDeliverySummaryForPurchase = async (branchId, purchaseId) =>
  (await axios.get(`${API_URL}/branch/${branchId}/delivery-guides/summary/${purchaseId}`, withAuth())).data;
